<template>
    <iframe class="responsive-iframe" :src="homeDashboard" frameborder="0" style="border:0" allowfullscreen></iframe>
</template>

<script>
import Vue from "vue";
import { Auth, oAuth } from "../../../classes/Auth";
export default Vue.extend({
  name: "Dashboard10",
  props: {
    source: String,
  },
  data: () => ({
      homeDashboard: '',
      auth: new Auth()
  }),
  mounted(){
    if(this.auth.getProject().name == 'DAVIVIENDA'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/065a214d-ada6-4588-9bad-6bcca0cc7245/page/8VcaB"
    }
    if(this.auth.getProject().name == 'DOLLARCITY'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/e11770b6-377f-4641-a553-23a7788c54c2/page/8VcaB"
    }
    if(this.auth.getProject().name == 'EAAV ESP'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/e10d6f5a-e7c8-4f7e-af42-70e3e4f7a940/page/8VcaB"
    }
    if(this.auth.getProject().name == 'MAKRO'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/c601dd91-132c-4add-9e7c-0f8b47bae868/page/SAz2B"
    }
    if(this.auth.getProject().name == 'DEMO'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/a1ba89e8-370f-4109-a96b-598dbcf77b91/page/SAz2B"
    }
    if(this.auth.getProject().name == 'DAVIVIENDA II'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/ee921382-bfc5-492d-af19-02bb80215b2d/page/1M"
    }
  }
});
</script>
<style>
.container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>

